import React from "react";
import { useNavigate } from "react-router-dom";

const HeadNeckBackPT = () => {
  const navigate = useNavigate();

  return (
    <>
      <style>{`
        .hnb-page {
          min-height: 100vh;
          width: 100%;
          background: radial-gradient(circle at top left, #eef2ff 0, #f9fafb 40%, #e5e7eb 100%);
          font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
          color: #0f172a;
        }

        .hnb-inner {
          max-width: 1200px;
          margin: 0 auto;
          padding: 32px 16px 72px;
        }

        /* HERO */
        .hnb-hero {
          padding: 26px 22px 34px;
          border-radius: 28px;
          background: linear-gradient(120deg, rgba(129, 140, 248, 0.2), rgba(96, 165, 250, 0.08));
          margin-bottom: 36px;
          display: grid;
          grid-template-columns: minmax(0, 1.5fr) minmax(0, 1.1fr);
          gap: 24px;
          align-items: center;
        }

        @media (max-width: 820px) {
          .hnb-hero {
            grid-template-columns: 1fr;
          }
        }

        .hnb-tag {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          padding: 5px 12px;
          border-radius: 999px;
          background: rgba(129, 140, 248, 0.24);
          color: #3730a3;
          font-size: 12px;
          font-weight: 600;
          text-transform: uppercase;
          letter-spacing: 0.08em;
          margin-bottom: 8px;
        }

        .hnb-tagDot {
          width: 6px;
          height: 6px;
          border-radius: 999px;
          background: #4f46e5;
        }

        .hnb-title {
          font-size: clamp(28px, 4vw, 38px);
          font-weight: 800;
          line-height: 1.1;
          margin-bottom: 10px;
        }

        .hnb-subtitle {
          font-size: 15px;
          max-width: 560px;
          color: #374151;
        }

        .hnb-chips {
          display: flex;
          flex-wrap: wrap;
          gap: 8px;
          margin: 16px 0 18px;
        }

        .hnb-chip {
          padding: 6px 12px;
          border-radius: 999px;
          background: #0f172a;
          color: #f9fafb;
          font-size: 11px;
        }

        .hnb-ctaRow {
          display: flex;
          flex-wrap: wrap;
          gap: 10px;
          margin-top: 10px;
        }

        .hnb-btnPrimary,
        .hnb-btnSecondary {
          border-radius: 999px;
          border: none;
          font-size: 14px;
          padding: 9px 18px;
          cursor: pointer;
          display: inline-flex;
          align-items: center;
          gap: 6px;
          transition: transform 0.12s ease, box-shadow 0.12s ease, background 0.12s ease;
        }

        .hnb-btnPrimary {
          background: #4f46e5;
          color: #eef2ff;
          box-shadow: 0 10px 24px rgba(79, 70, 229, 0.4);
        }

        .hnb-btnPrimary:hover {
          transform: translateY(-1px);
          box-shadow: 0 14px 32px rgba(79, 70, 229, 0.55);
        }

        .hnb-btnSecondary {
          background: rgba(15, 23, 42, 0.06);
          color: #111827;
          border: 1px solid rgba(148, 163, 184, 0.7);
        }

        .hnb-btnSecondary:hover {
          background: rgba(15, 23, 42, 0.1);
          transform: translateY(-1px);
        }

        .hnb-heroImgWrap {
          display: flex;
          justify-content: center;
        }

        .hnb-heroImg {
          width: 100%;
          max-width: 380px;
          border-radius: 24px;
          object-fit: cover;
          box-shadow: 0 18px 38px rgba(15, 23, 42, 0.24);
        }

        /* GENERIC SECTIONS */
        .hnb-stripe {
          padding: 32px 0;
          border-bottom: 1px solid rgba(148, 163, 184, 0.35);
        }

        .hnb-sectionTitle {
          font-size: 21px;
          font-weight: 800;
          margin-bottom: 8px;
        }

        .hnb-sectionSubtitle {
          font-size: 14px;
          color: #4b5563;
          margin-bottom: 18px;
        }

        .hnb-flexRow {
          display: flex;
          flex-wrap: wrap;
          gap: 24px;
          align-items: center;
        }

        .hnb-flexCol {
          flex: 1 1 260px;
        }

        .hnb-img {
          width: 100%;
          max-width: 360px;
          border-radius: 22px;
          object-fit: cover;
          box-shadow: 0 14px 30px rgba(15, 23, 42, 0.18);
        }

        /* LISTS */
        .hnb-list {
          list-style: none;
          padding: 0;
          margin: 0;
          display: grid;
          gap: 8px;
        }

        .hnb-list li {
          display: flex;
          gap: 8px;
          font-size: 14px;
          color: #111827;
        }

        .hnb-bullet {
          width: 7px;
          height: 7px;
          border-radius: 999px;
          background: #4f46e5;
          margin-top: 6px;
          flex-shrink: 0;
        }

        /* CARD GRID */
        .hnb-cardGrid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
          gap: 16px;
          margin-top: 18px;
        }

        .hnb-card {
          padding: 12px 14px;
          border-radius: 18px;
          background: rgba(15, 23, 42, 0.02);
          border: 1px solid rgba(148, 163, 184, 0.5);
        }

        .hnb-cardTitle {
          font-size: 13px;
          font-weight: 700;
          margin-bottom: 4px;
        }

        .hnb-cardText {
          font-size: 12px;
          color: #4b5563;
        }

        /* TIMELINE */
        .hnb-timeline {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
          gap: 10px;
        }

        .hnb-step {
          padding: 10px 12px;
          border-radius: 18px;
          background: rgba(15, 23, 42, 0.03);
        }

        .hnb-stepLabel {
          font-size: 12px;
          font-weight: 700;
          margin-bottom: 4px;
        }

        .hnb-stepText {
          font-size: 12px;
          color: #4b5563;
        }

        /* BANNER */
        .hnb-banner {
          position: relative;
          border-radius: 26px;
          overflow: hidden;
          margin-top: 24px;
        }

        .hnb-banner img {
          width: 100%;
          height: 240px;
          object-fit: cover;
          display: block;
        }

        @media (min-width: 768px) {
          .hnb-banner img {
            height: 270px;
          }
        }

        .hnb-bannerOverlay {
          position: absolute;
          inset: 0;
          background: linear-gradient(90deg, rgba(15, 23, 42, 0.82), transparent 60%);
          display: flex;
          flex-direction: column;
          justify-content: center;
          padding: 18px 20px;
          gap: 10px;
        }

        .hnb-bannerText {
          color: #e0e7ff;
          font-size: 15px;
          max-width: 420px;
        }

        .hnb-bannerButtons {
          display: flex;
          flex-wrap: wrap;
          gap: 8px;
        }

        .hnb-bannerButtons button {
          font-size: 12px;
          padding: 8px 14px;
          border-radius: 999px;
          border: none;
          cursor: pointer;
        }

        .hnb-bannerButtons .primary {
          background: #22c55e;
          color: #022c22;
        }

        .hnb-bannerButtons .secondary {
          background: rgba(255,255,255,0.16);
          color: #f9fafb;
          border: 1px solid rgba(255,255,255,0.6);
        }

        /* BOTTOM STRIP */
        .hnb-bottomStrip {
          margin-top: 24px;
          padding: 14px 14px;
          border-radius: 22px;
          background: #0f172a;
          display: flex;
          flex-wrap: wrap;
          gap: 12px;
          align-items: center;
          justify-content: space-between;
        }

        .hnb-bottomText {
          font-size: 12px;
          color: #e5e7eb;
          flex: 1 1 240px;
        }

        .hnb-bottomText strong {
          color: #fef9c3;
        }

        .hnb-bottomActions {
          display: flex;
          flex-wrap: wrap;
          gap: 8px;
        }

        .hnb-bottomActions button {
          font-size: 12px;
          padding: 7px 12px;
          border-radius: 999px;
          border: none;
          cursor: pointer;
        }

        .hnb-bottomActions .primary {
          background: #4f46e5;
          color: #eef2ff;
        }

        .hnb-bottomActions .secondary {
          background: transparent;
          color: #e5e7eb;
          border: 1px solid rgba(148, 163, 184, 0.8);
        }

        @media (max-width: 640px) {
          .hnb-title {
            font-size: 26px;
          }
        }
      `}</style>

      <div className="hnb-page">
        <div className="hnb-inner">
          {/* HERO */}
          <section className="hnb-hero">
            <div>
              <div className="hnb-tag">
                <span className="hnb-tagDot" />
                Head & Neck · Back
              </div>
              <h1 className="hnb-title">
                Ease back-of-neck and upper shoulder tension so your head feels lighter.
              </h1>
              <p className="hnb-subtitle">
                The back of your neck and upper shoulders — including the cervical spine, upper trapezius,
                and levator scapulae — help support your head all day. When they&apos;re tight or irritated,
                they can create aching, stiffness, or tension-type headaches.
              </p>

              <div className="hnb-chips">
                <span className="hnb-chip">Back-of-neck tightness</span>
                <span className="hnb-chip">Upper shoulder tension</span>
                <span className="hnb-chip">Desk posture strain</span>
                <span className="hnb-chip">Tension-style headaches</span>
              </div>

              <div className="hnb-ctaRow">
                <button
                  className="hnb-btnPrimary"
                  onClick={() => navigate("/appointments")}
                >
                  Book a neck & upper back visit →
                </button>
                <button
                  className="hnb-btnSecondary"
                  onClick={() => navigate("/staff")}
                >
                  Meet our therapists
                </button>
              </div>
            </div>

            <div className="hnb-heroImgWrap">
              <img
                src="/content/head-neck-back/head_neck_back_hero.png"
                alt="Therapist assessing back of neck in clinic"
                className="hnb-heroImg"
              />
            </div>
          </section>

          {/* WHAT CAN GO WRONG */}
          <section className="hnb-stripe">
            <div className="hnb-sectionTitle">What can go wrong at the back of the head & neck?</div>
            <p className="hnb-sectionSubtitle">
              These muscles and joints help hold up the weight of your head and support everything
              from looking at screens to driving. When they&apos;re overloaded, they can signal with pain,
              stiffness, or fatigue.
            </p>

            <div className="hnb-flexRow">
              <div className="hnb-flexCol">
                <ul className="hnb-list">
                  <li>
                    <span className="hnb-bullet" />
                    <span>
                      <strong>Cervical spine stiffness:</strong> difficulty turning or tilting your
                      head, especially after long periods in one position.
                    </span>
                  </li>
                  <li>
                    <span className="hnb-bullet" />
                    <span>
                      <strong>Upper trapezius tightness:</strong> “knots” across the top of the
                      shoulders or base of the neck.
                    </span>
                  </li>
                  <li>
                    <span className="hnb-bullet" />
                    <span>
                      <strong>Levator scapulae strain:</strong> pain along the side/back of the neck,
                      often worse when turning or looking down.
                    </span>
                  </li>
                  <li>
                    <span className="hnb-bullet" />
                    <span>
                      <strong>Tension-related headaches:</strong> pressure or aching that starts in
                      the neck and wraps around to the head or behind the eyes.
                    </span>
                  </li>
                </ul>

                <div className="hnb-ctaRow" style={{ marginTop: "14px" }}>
                  <button
                    className="hnb-btnPrimary"
                    onClick={() => navigate("/appointments")}
                  >
                    See if your symptoms match →
                  </button>
                  <button
                    className="hnb-btnSecondary"
                    onClick={() => navigate("/contact")}
                  >
                    Ask a quick question
                  </button>
                </div>
              </div>

              <div className="hnb-flexCol" style={{ display: "flex", justifyContent: "center" }}>
                <img
                  src="/content/head-neck-back/head_neck_upper_traps.png"
                  alt="Soft tissue work on upper trapezius"
                  className="hnb-img"
                />
              </div>
            </div>

            <div className="hnb-cardGrid">
              <div className="hnb-card">
                <div className="hnb-cardTitle">Neck / Cervical Spine</div>
                <div className="hnb-cardText">
                  The upper spine that supports your head and allows turning, looking up, and nodding.
                </div>
              </div>
              <div className="hnb-card">
                <div className="hnb-cardTitle">Upper Trapezius</div>
                <div className="hnb-cardText">
                  Runs from the neck to the shoulders; often tight with desk work, stress, or carrying bags.
                </div>
              </div>
              <div className="hnb-card">
                <div className="hnb-cardTitle">Levator Scapulae</div>
                <div className="hnb-cardText">
                  Connects the neck to the shoulder blade; can cause localized neck pain and stiffness.
                </div>
              </div>
            </div>
          </section>

          {/* HOW PT HELPS */}
          <section className="hnb-stripe">
            <div className="hnb-flexRow">
              <div className="hnb-flexCol">
                <img
                  src="/content/head-neck-back/head_neck_levator.png"
                  alt="Therapist treating levator scapulae and neck"
                  className="hnb-img"
                />
              </div>

              <div className="hnb-flexCol">
                <div className="hnb-sectionTitle">How physical therapy supports the back of the neck</div>
                <p className="hnb-sectionSubtitle">
                  We look at how your neck joints, upper back, and shoulder muscles are sharing the work
                  of holding up your head.
                </p>

                <ul className="hnb-list">
                  <li>
                    <span className="hnb-bullet" />
                    <span>
                      <strong>Gentle joint mobilization:</strong> to improve comfortable motion
                      through the cervical spine.
                    </span>
                  </li>
                  <li>
                    <span className="hnb-bullet" />
                    <span>
                      <strong>Soft-tissue techniques:</strong> for upper traps, levator scapulae,
                      and surrounding muscles to reduce “guarding.”
                    </span>
                  </li>
                  <li>
                    <span className="hnb-bullet" />
                    <span>
                      <strong>Posture & position tweaks:</strong> small changes to how you sit, use
                      screens, or sleep to reduce strain.
                    </span>
                  </li>
                  <li>
                    <span className="hnb-bullet" />
                    <span>
                      <strong>Strength & endurance work:</strong> building support in deep neck
                      muscles and upper back so bigger muscles don&apos;t overwork.
                    </span>
                  </li>
                </ul>

                <div className="hnb-ctaRow" style={{ marginTop: "14px" }}>
                  <button
                    className="hnb-btnPrimary"
                    onClick={() => navigate("/appointments")}
                  >
                    Start with one neck session →
                  </button>
                  <button
                    className="hnb-btnSecondary"
                    onClick={() => navigate("/insurance")}
                  >
                    Check my insurance
                  </button>
                </div>
              </div>
            </div>
          </section>

          {/* VISIT FLOW */}
          <section className="hnb-stripe">
            <div className="hnb-sectionTitle">What a head & neck (back) visit may look like</div>

            <div className="hnb-flexRow">
              <div className="hnb-flexCol">
                <img
                  src="/content/head-neck-back/head_neck_cervical_mobility.png"
                  alt="Guided cervical mobility from behind the patient"
                  className="hnb-img"
                />
              </div>

              <div className="hnb-flexCol">
                <div className="hnb-timeline">
                  <div className="hnb-step">
                    <div className="hnb-stepLabel">1. Your story</div>
                    <div className="hnb-stepText">
                      We talk through when the neck or head discomfort started, what seems to trigger it,
                      and what you&apos;d like to get back to.
                    </div>
                  </div>
                  <div className="hnb-step">
                    <div className="hnb-stepLabel">2. Motion & strength check</div>
                    <div className="hnb-stepText">
                      We look at neck range of motion, upper back movement, and muscle tension patterns.
                    </div>
                  </div>
                  <div className="hnb-step">
                    <div className="hnb-stepLabel">3. Hands-on care</div>
                    <div className="hnb-stepText">
                      You try specific manual techniques and guided movements to see what eases tension.
                    </div>
                  </div>
                  <div className="hnb-step">
                    <div className="hnb-stepLabel">4. Short home plan</div>
                    <div className="hnb-stepText">
                      You leave with a few realistic exercises and position tips you can use during the day.
                    </div>
                  </div>
                </div>

                <div className="hnb-ctaRow" style={{ marginTop: "14px" }}>
                  <button
                    className="hnb-btnPrimary"
                    onClick={() => navigate("/appointments")}
                  >
                    Book a neck & upper back evaluation →
                  </button>
                </div>
              </div>
            </div>
          </section>

          {/* BANNER */}
          <section className="hnb-stripe">
            <div className="hnb-banner">
              <img
                src="/content/head-neck-back/head_neck_back_banner.png"
                alt="Bright physical therapy clinic for neck and upper back care"
              />
              <div className="hnb-bannerOverlay">
                <div className="hnb-bannerText">
                  Neck and upper shoulder sessions happen in a calm, one-on-one setting where we
                  match your plan to your comfort level, work demands, and daily life.
                </div>
                <div className="hnb-bannerButtons">
                  <button
                    className="primary"
                    onClick={() => navigate("/appointments")}
                  >
                    Schedule a neck-focused visit →
                  </button>
                  <button
                    className="secondary"
                    onClick={() => navigate("/office")}
                  >
                    View locations
                  </button>
                </div>
              </div>
            </div>
          </section>

          {/* SAFETY NOTE */}
          <section className="hnb-stripe">
            <div className="hnb-bottomStrip">
              <div className="hnb-bottomText">
                If you notice sudden severe neck pain after an accident, loss of strength in your arms,
                trouble walking, changes in vision, speech, or balance, or headache that feels very different
                than usual,{" "}
                <strong>seek medical or emergency care first.</strong> Physical therapy can then help support
                recovery once serious causes are ruled out.
              </div>
              <div className="hnb-bottomActions">
                <button
                  className="primary"
                  onClick={() => navigate("/appointments")}
                >
                  Schedule neck PT
                </button>
                <button
                  className="secondary"
                  onClick={() => navigate("/contact")}
                >
                  Message our team
                </button>
              </div>
            </div>
          </section>

        </div>
      </div>
    </>
  );
};

export default HeadNeckBackPT;
